export default __webpack_public_path__ + "static/media/about-greeting-3.4cf8c6be.png";